import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import StockIndicatorContext, { settingsDefaults } from './StockIndicatorContext.js';

const createContext = (settings = {})=>{
    return swcHelpers.objectSpread({}, settingsDefaults, settings);
};
const StockIndicatorProvider = ({ children , settings ,  })=>/*#__PURE__*/ React.createElement(StockIndicatorContext.Provider, {
        value: createContext(settings)
    }, children)
;

export { StockIndicatorProvider as default };
//# sourceMappingURL=StockIndicatorProvider.js.map
